if (!customElements.get('kiukiang-product-context')) {
  customElements.define('kiukiang-product-context', class extends HTMLElement {
    connectedCallback() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const main = document.querySelector('product-info[data-update-url="true"]');
        if (!main || main.dataset.section !== data.sectionId || !data.variant) return;
        this.querySelector('[data-product-context-variant]').value = data.variant.title === 'Default Title' ? '' : data.variant.title;
        this.querySelector('[data-product-context-variant-label]').hidden = data.variant.title === 'Default Title';
        this.querySelector('[data-product-context-id]').value = data.variant.id;
        const url = new URL(this.dataset.productUrl, window.location.origin);
        url.searchParams.set('variant', data.variant.id);
        this.querySelector('[data-product-context-url]').value = url.href;
      });
    }
    disconnectedCallback() { this.unsubscribeVariant?.(); }
  });
}
